export default __webpack_public_path__ + "static/media/newslet.b24838a7.png";